<div class="col-md-12 content-wrapper align-items-center">
    <app-change-password-form (submitted)="onChangePasswordSubmitted($event)" [error]="error"></app-change-password-form>
</div>